import { HttpRequest, HttpParams, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = this.authenticationService.currentUserValue;
    const language = localStorage.getItem('language') || 'en';

    const requestHeader = {
      'accept-language': language,
      lang: language,
    } as any;

    if (currentUser && currentUser.Token) {
      requestHeader.Authorization = `Bearer ${currentUser.Token}`;
      requestHeader.refreshToken = currentUser.RefreshToken;
    }
    // if (tenant && tenant.tenantId) {
    //   requestHeader.tenantId = String(tenant.tenantId);
    // }

    request = request.clone({
      setHeaders: requestHeader,
      params: new HttpParams({ fromObject: this.setDateParams(request.params) })
    });

    this.dateReplacer(request.body);
    return next.handle(request);
  }

  setDateParams(params: HttpParams) {
    const paramsValue: any = {};
    params.keys().forEach(p => {
      const value = params.get(p) as any;
      if (this.isValidDate(value)) {
        paramsValue[p] = this.makeDate(value);
      } else if (value !== undefined && value !== 'undefined') {
        paramsValue[p] = value;
      }
    });
    return paramsValue;
  }

  isValidDate(value: string | null): boolean {
    if (!value) return false;

    // Check if value is purely numeric (not a date)
    if (!isNaN(Number(value))) {
      return false; // Reject pure numbers
    }

    const datePattern = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \([\w\s]+\)$/;
    if (!datePattern.test(value)) {
      return false;
    }

    // Try parsing as a Date
    const date = new Date(value);
    return !isNaN(date.getTime()); // Valid date object
  }

  makeDate(date: Date) {
    date = new Date(date);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return year + '/' + month + '/' + day;
  }

  dateReplacer(obj: any) {
    if (obj) {
      for (const k in obj) {
        if (obj.hasOwnProperty(k)) {
          if (obj[k] instanceof Object) {
            obj[k] = this.dateReplacer(obj[k]);
          }
          if (obj[k] instanceof Date) {
            obj[k] = new Date(`${obj[k]} UTC`);
          }
        }
      }
      return obj;
    }
  }
}
